import { render } from "./ExerciseThreadList.vue?vue&type=template&id=2e4773f3&ts=true"
import script from "./ExerciseThreadList.vue?vue&type=script&lang=ts"
export * from "./ExerciseThreadList.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__